<template>
  <div class="main-background">
    <button type="button" class="filter-page-back-button" aria-label="Назад до товарів" @click="returnToLastPage">
      <chevron-left-icon class="back-button-icon" aria-hidden="true" />
      <span class="back-button-text">Про товар</span>
    </button>
    <request-state :loading="productState.loading" :error="productState.error" loading-text="Завантажуємо товар…" @retry="retryProduct" />
    <template v-if="!productState.loading && !productState.error && openedProduct.id">
      <div class="main-image-container">
        <img :src="openedProduct.img" :alt="openedProduct.name" class="main-image" />
        <div>
          <h1 class="product-info-name">{{ openedProduct.name }}</h1>
          <div class="price-counter-line-container">
            <product-price :price="openedProduct.price" :old-price="openedProduct.price_old" large show-discount />
            <div class="product-counter-container">
              <button type="button" :disabled="busy || Number(productCounter) <= 1" class="product-counter-button" aria-label="Зменшити кількість товару" @click="setChangeCounter('-')"><minus-icon aria-hidden="true" class="product-counter-button-icon" /></button>
              <input type="text" inputmode="numeric" class="product-counter-input" aria-label="Кількість товару для додавання" :disabled="busy || available < 1" @keyup.enter="handleEnterKey" v-model="productCounter" @input="validateInput" @blur="normalizeQuantity" />
              <button type="button" :disabled="busy || Number(productCounter) >= available" class="product-counter-button" aria-label="Збільшити кількість товару" @click="setChangeCounter('+')"><plus-icon aria-hidden="true" class="product-counter-button-icon" /></button>
            </div>
          </div>
          <p v-if="currentQuantity" class="product-code" role="status">У кошику: {{ currentQuantity }}</p>
        </div>
        <div class="small-descr-container">
          <p class="product-code">{{ openedProduct.code ? 'Артикул: ' + openedProduct.code : 'Код: ' + openedProduct.id }}</p>
          <product-availability :product="openedProduct" /><favorite-button :product="openedProduct" />
        </div>
      </div>
      <div class="product-info-container">
        <p class="product-info-title">Опис</p>
        <div class="product-info" v-html="formattedDescription"></div>
      </div>
      <div class="bottom-filter-button-container">
        <p v-if="cartError" class="action-error" role="alert">{{ cartError }}</p>
        <button type="button" class="filtration-button" :disabled="busy || !cartReady || available < 1 || Number(productCounter) < 1" @click="setAddproductToCart">
          {{ busy ? 'Додаємо…' : available === 0 ? 'Більше немає в наявності' : currentQuantity ? 'Додати ще' : 'Додати у кошик' }}
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import { formatDescription } from '../helpers/description';
import ProductAvailability from '../../../components/ProductAvailability.vue';
import FavoriteButton from '../../../components/FavoriteButton.vue';

import { ChevronLeftIcon, PlusIcon, MinusIcon } from 'vue-feather-icons'
import ProductPrice from "../../../components/ProductPrice.vue"
import RequestState from "../../../components/RequestState.vue"

export default {
    name: "product-page",
    components: { ProductAvailability, FavoriteButton,
        ChevronLeftIcon,
        ProductPrice,
        RequestState,
        PlusIcon,
        MinusIcon
    },
    props: {
        perPage: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            mainOpenProduct: {
                id: null,
                img: null,
                name: null,
                price: null
            },
            productCounter: 1,
            busy: false,
            cartError: ""
        }
    },
    mounted() {
        console.log('Product info page opened');
        window.scrollTo(0, 0);
    },
    computed: {
       productState() { return this.$store.getters.resources.product },
       cartReady() { return this.$store.getters.cartReady && !this.$store.getters.cartUpdating },
       currentQuantity() {
         const item = (this.getCustomerCart.items || []).find(item => String(item.product_id) === String(this.openedProduct.id) && !item.no_product)
         return Number(item?.qty_item) || 0
       },
       available() { return this.openedProduct.available === false ? 0 : Math.max(0, Number(this.openedProduct.qty) - this.currentQuantity) },
       openedProduct() {
         return this.$store.getters.openedProduct
       },
       perPageName() {
         return this.$store.getters.perPageName
       },
       getOrderId() {
        return this.$store.getters.getOrderId
       },
       getCustomerCart() {
        return this.$store.getters.getCustomerCart
       },
       discountPercent() {
        const oldPrice = Number(this.openedProduct.price_old)
        const newPrice = Number(this.openedProduct.price)
        if (!oldPrice || !newPrice || oldPrice <= newPrice) return 0
        return Math.round((1 - newPrice / oldPrice) * 100)
       },
       formattedDescription() { return formatDescription(this.openedProduct.description) }
    },
    methods: {
        handleEnterKey() {
            const activeElement = document.activeElement
            if (activeElement.tagName === 'INPUT') {
            activeElement.blur()
            }
       },
        retryProduct() { return this.$store.dispatch('getOneProduct', this.openedProduct.id) },
        validateInput() {
            this.productCounter = String(this.productCounter).replace(/\D/g, '')
            if (Number(this.productCounter) > this.available) this.productCounter = this.available
        },
        normalizeQuantity() { this.productCounter = Math.max(1, Math.min(Number(this.productCounter) || 1, this.available)) },
        setChangeCounter(value) {
            this.productCounter = Math.max(1, Math.min(Number(this.productCounter) + (value === '+' ? 1 : -1), this.available))
        },
        async setAddproductToCart() {
            if (this.busy || !this.cartReady || this.available < 1) return
            this.busy = true
            this.cartError = ''
            try {
                await this.$store.dispatch('addProductFromDetails', { product: this.openedProduct, quantity: Number(this.productCounter) })
                this.productCounter = 1
            } catch (error) {
                await this.$store.dispatch('getCart')
                this.cartError = 'Не вдалося підтвердити додавання. Перевірте кількість у кошику та спробуйте ще раз.'
            } finally { this.busy = false }
        },
        returnToLastPage() {
            if (this.perPageName === 'favorites') {
                this.$emit('setIsChangePage', 'favorites')
            } else if (this.perPageName === 'cart') {
                this.$emit('setIsChangePage', 'cart')
            } else if (this.perPageName === 'home') {
                this.$emit('setIsChangePage', 'home', '')
            } else {
                this.$emit('setIsChangePage', 'product', 'productInfo')
            }
        }
    },
    watch: {

    }
}
</script>

<style scoped>
.product-info { overflow-wrap: anywhere; }
.product-info ::v-deep .desc-paragraph { margin: 0 0 16px; line-height: 1.65; }
.product-info ::v-deep .desc-list { padding-left: 24px; margin: 0 0 16px; list-style-position: outside; }
.product-info ::v-deep ul.desc-list { list-style-type: disc; }
.product-info ::v-deep ol.desc-list { list-style-type: decimal; }

.small-descr-container {
    display: flex;
    justify-content: space-between;
}

.main-background {
    background: #fff;
}
.filter-page-back-button {
    position: relative;
    border-bottom: 1px solid #F0F0F0;
    padding: 18px;
    cursor: pointer;
}

.back-button-icon {
    position: absolute;
}

.back-button-text {
    text-align: center;
}

.main-image-container {
   width: 100%;
   padding: 0 16px; 
   border-bottom: 1px solid #F0F0F0;
}

.main-image {
    width: 100%;
    /* height: 375px;  */
}

.bottom-filter-button-container {
  position: fixed;
  bottom: -2px;
  width: 100%;
  left: 0px;
  background: #FFF;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
}

.filtration-button {
    padding: 12px;
    width: 100%;
    border-radius: 8px;
    background: #16ABB8;  
    color: #FFF;
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    border: none;
    cursor: pointer;
}

.product-info-name {
    color: #333;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    max-width: 250px;
}

.product-price-container {
    display: flex;
    gap: 6px;
}

.product-price-name {
    color: #333;
font-family: Inter;
font-size: 18px;
font-weight: 600;
line-height: 24px;
}

.product-price {
 color: #E3000F;
font-family: Inter;
font-size: 18px;
font-weight: 500;
line-height: 24px;
}

.product-sale {
  color: rgba(227, 0, 15, 0.60);
font-family: Inter;
font-size: 14px;
font-weight: 500;
line-height: 24px;  
}

.closed-price {
    position: relative;
}

.closed-price-line {
    position: absolute;
    width: 95%;
    height: 1px;
    background: rgba(227, 0, 15, 0.60);
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    transform: rotate(-15deg);
    top: 13px; 
}

.price-counter-line-container {
    display: flex;
    margin: 8px 0;
}

.product-counter-container {
    display: flex;
    gap: 4px;
    margin-left: auto;
}
.product-counter-button {
    border: 1px solid #C4C4C4;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    cursor: pointer;
}
.product-counter-button-icon {
    width: 8px;
    height: 8px;
}
.product-counter-input {
    width: 40px;
    height: 24px;
    border-radius: 4px;
    background: #F0F0F0;
    border: none;
    text-align: center;
    outline-offset: 0;
    outline: 0;
    color: #707070;
    text-align: center;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
}
.product-code {
    color: #707070;
    font-family: Inter;
    font-size: 10px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 6px;
}
.product-info-container {
    padding: 0 16px;
    padding-bottom: calc(110px + env(safe-area-inset-bottom, 0px));
}
.product-info-title {
    margin-top: 11px;
    color: #333;
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
}
.product-info {
    color: #707070;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin-top: 3px;
}
/* Форматування опису (контент рендериться через v-html) */
.product-info >>> .desc-paragraph {
    margin-bottom: 10px;
}
.product-info >>> .desc-paragraph:last-child {
    margin-bottom: 0;
}
.product-info >>> .desc-list { padding-left: 24px; margin: 8px 0 16px; }
.product-info >>> ul.desc-list { list-style-type: disc; }
.product-info >>> ol.desc-list { list-style-type: decimal; }
.product-info >>> .desc-list li { margin-bottom: 8px; line-height: 1.65; }
.discount-badge {
    align-self: center;
    background: #E3000F;
    color: #fff;
    font-family: Inter;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    padding: 2px 8px;
    border-radius: 6px;
    white-space: nowrap;
}
.add-cart-bbutton {
    vertical-align: bottom;
}

/* === Значні покращення для великих екранів (1024px+) === */
@media (min-width: 1024px) {
  .main-background {
    max-width: 1400px;
    margin: 0 auto;
    padding: 32px 32px 160px 32px;
    background: #f7f9fb;
  }

  .filter-page-back-button {
    max-width: 1400px;
    margin: 0 auto;
    padding: 24px 40px;
    border-bottom: 1px solid #f0f0f0;
  }

  .back-button-text {
    font-size: 20px;
    font-weight: 600;
  }

  /* Двоколонковий layout */
  .main-image-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px;
    display: grid;
    grid-template-columns: 0.6fr 1.3fr;
    gap: 20px;
    align-items: start;
    border-bottom: none;
    background: #fff;
    border-radius: 24px;
    box-shadow: 0 12px 36px rgba(18, 38, 63, 0.08);
  }

  /* Зображення продукту */
  .main-image {
    width: 100%;
    max-width: 440px;
    border-radius: 20px;
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.12);
    transition: transform 0.3s ease;
  }

  .main-image:hover {
    transform: scale(1.02);
  }

  /* Інформація про продукт */
  .product-info-name {
    max-width: 100%;
    font-size: 32px;
    font-weight: 700;
    line-height: 42px;
    margin-bottom: 18px;
    color: #1a1a1a;
  }

  .small-descr-container {
    margin: 0;
    padding: 12px 16px;
    background: #f3f6fb;
    border-radius: 12px;
    display: inline-flex;
    gap: 16px;
  }

  .product-code {
    font-size: 13px;
    margin-bottom: 0;
    color: #5c6674;
  }

  .price-counter-line-container {
    margin: 24px 0 12px 0;
    align-items: center;
    padding: 18px 20px;
    background: #f9fbff;
    border-radius: 14px;
    border: 1px solid #e6ecf3;
  }

  .product-price-container {
    gap: 16px;
    align-items: center;
  }

  .product-price-name {
    font-size: 20px;
    font-weight: 600;
  }

  .product-price {
    font-size: 28px;
    font-weight: 700;
    color: #E3000F;
  }

  .product-sale {
    font-size: 20px;
  }

  .closed-price-line {
    width: 100%;
  }

  /* Счетчик */
  .product-counter-container {
    gap: 8px;
  }

  .product-counter-button {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    transition: all 0.2s ease;
    background: #fff;
    border: 1px solid #d9e1ea;
  }

  .product-counter-button:hover:not(:disabled) {
    background: #eef3fb;
    transform: scale(1.1);
  }

  .product-counter-input {
    width: 60px;
    height: 36px;
    font-size: 16px;
    background: #fff;
    border: 1px solid #d9e1ea;
  }

  /* Опис */
  .product-info-container {
    max-width: 1400px;
    margin: 20px auto 0 auto;
    padding: 20px;
    background: #fff;
    border-radius: 24px;
    box-shadow: 0 10px 30px rgba(18, 38, 63, 0.06);
  }

  .product-info-title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
    color: #1a1a1a;
  }

  .product-info {
    font-size: 18px;
    line-height: 32px;
    max-width: 100%;
    color: #4a4a4a;
  }

  /* Кнопка додавання */
  .bottom-filter-button-container {
    max-width: 1400px;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    padding: 20px 30px;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, rgba(247, 249, 251, 0.85) 0%, #ffffff 40%);
  }

  .filtration-button {
    max-width: 600px;
    margin: 0 auto;
    font-size: 22px;
    font-weight: 700;
    padding: 20px;
    border-radius: 16px;
    transition: all 0.3s ease;
  }

  .filtration-button:hover {
    background: #14a0ad;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(22, 171, 184, 0.4);
  }

  .add-cart-bbutton {
    width: 24px;
    height: 24px;
    vertical-align: middle;
    margin-right: 8px;
  }
}

</style>
<style scoped>
.main-background { padding-bottom: 140px; }
.filter-page-back-button { width: 100%; background: #fff; border: 0; border-bottom: 1px solid #f0f0f0; cursor: pointer; }
.product-counter-button { min-width: 44px; min-height: 44px; }
.product-counter-input { min-height: 44px; width: 48px; }
.product-counter-button-icon { width: 18px; height: 18px; }
.action-error { color: #a42020; font-size: 14px; line-height: 20px; margin-bottom: 8px; }
</style>
